const STORAGE_KEY = 'skhaftin-lite-mode';

export const isLiteModeEnabled = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setLiteModeEnabled = (enabled) => {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
    window.dispatchEvent(new CustomEvent('skhaftin-lite-mode', { detail: { enabled } }));
  } catch {
    // Ignore storage failures.
  }
};

export const subscribeLiteMode = (callback) => {
  const handler = (event) => callback(Boolean(event?.detail?.enabled));
  window.addEventListener('skhaftin-lite-mode', handler);
  return () => window.removeEventListener('skhaftin-lite-mode', handler);
};
